import { render, staticRenderFns } from "./TrendSearchItem.vue?vue&type=template&id=5d0cdf5c"
import script from "./TrendSearchItem.vue?vue&type=script&lang=js"
export * from "./TrendSearchItem.vue?vue&type=script&lang=js"
import style0 from "./TrendSearchItem.vue?vue&type=style&index=0&id=5d0cdf5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports